import cloneDeep from 'lodash.clonedeep';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

interface OptionItem { libelle: string; code: string; }

@Component({
  selector: 'app-other-option',
  templateUrl: './other-option.component.html',
  styleUrls: ['./other-option.component.scss']
})
export class OtherOptionComponent implements OnInit {

  @Input() optionsWithCode: OptionItem[] = [];
  @Output() valueSelectedOutput: EventEmitter<any> = new EventEmitter();

  optionsFiltered: Array<any> = [];
  searchValue: string = "";

  label1 = 'eform-editable.other-option-label-1'
  label2 = 'eform-editable.other-option-label-2'
  label3 = 'eform-editable.other-option-label-3'
  labelClose = 'eform-editable.other-option-close'
  labelValider = 'eform-editable.other-option-valider'
  labelAnnuler = 'eform-editable.other-option-annuler'

  valueSelected: any = "";

  constructor(
    private ngbActiveModal: NgbActiveModal,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.optionsFiltered = this.dedupeByCode(cloneDeep(this.optionsWithCode ?? []));
  }

  exitModal() {
    this.close(null);
  }

  dedupeByCode<T extends { code: string }>(arr: T[]): T[] {
    const a = arr ?? [];
    const seen = new Set<string>();
    return a.filter(item => {
      if (seen.has(item.code)) return false;
      seen.add(item.code);
      return true;
    });
  }

  close(value: any) {
    this.valueSelectedOutput.emit(value);
    this.ngbActiveModal.close();
  }

  valider() {
    this.close(this.valueSelected ? this.valueSelected : "EMPTY");
  }

  private escapeRegExp(input: string): string {
    return input.replace(/[.*+?^${}[\]\\|]/g, '\\$&');
  }

  search(searchValue: string) {
    const base = this.dedupeByCode(this.optionsWithCode ?? []);
    if (!searchValue) {
      this.optionsFiltered = cloneDeep(base);
      return;
    }
    let rx: RegExp | null = null;
    try {
      rx = new RegExp(this.escapeRegExp(searchValue), 'i');
    } catch { rx = null; }

    const mapped = base.map(el => ({
      libelle: this.translateService.instant(el.libelle),
      code: el.code
    }));

    this.optionsFiltered = rx
      ? mapped.filter(v => rx!.test(v.libelle) || rx!.test(v.code))
      : mapped;
  }

  changeRadio(item) {
    this.valueSelected = item;
  }
}
